import { Component, OnInit } from '@angular/core';
import { ScoringParametrage } from '../../core/model/ScoringParametrage';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ScoringParametreService } from '../../core/service/scoring-parametre.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { first } from 'rxjs/operators';

@Component({
  selector: "app-edit-scoring-parametre",
  templateUrl: "./edit-scoring-parametre.component.html",
  styleUrls: ["./edit-scoring-parametre.component.scss"]
})
export class EditScoringParametreComponent implements OnInit {
  scoringParametrage: ScoringParametrage;

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _scoringParametreService: ScoringParametreService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {}

  createForm(scoringParametrage: ScoringParametrage) {
    this.form2 = this.fb.group({
      code: [
        scoringParametrage.code,
        Validators.compose([Validators.required])
      ],
      libelle: [
        scoringParametrage.libelle,
        Validators.compose([Validators.required])
      ]
    });
  }

  ngOnInit() {
    this.createForm(this.scoringParametrage);
  }

  save(): void {
    this.spinner.show();

    this.pressButton = true;
    this.scoringParametrage.id = this.scoringParametrage.id;
    this.scoringParametrage = this.form2.value;

    this._scoringParametreService
      .update(this.scoringParametrage)
      .pipe(first())
      .subscribe(
        data => {
          this.spinner.hide();
          this.activeModal.close();
        },
        error => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }
}
